import features2 from "@/assets/images/user1.png";
import PageNotFound from "@/components/common/page-not-found/page-not-found";
import Layout from "@/layout/layout";
import { wrapper } from "@/store";
import { fetchBlogBySlug, selectBlog } from "@/store/slices/blog";
import {
  selectHelmet,
  setCanonical,
  setIgnoreCommonTitle,
  setMeta,
  setMetaModifiedTime,
  setOg,
  setPath,
  setSchemas,
  setTitle,
} from "@/store/slices/helmet";
import { getBlogCanonicalUrl } from "@/data/blogCanonicalMap";
import styles from "@/styles/blog_details.module.scss";
import moment from "moment-timezone";
import Image from "next/image";
import Link from "next/link";
import React, { ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Blog = () => {
  const blogState = useSelector(selectBlog);
  const helmetState = useSelector(selectHelmet);
  const [windowAvailable, setWindowAvailable] = useState(false);

  useEffect(() => setWindowAvailable(true), []);

  return (
    <>
      <article>
        <div className={styles.blog_bg}>
          <div className="container">
            <div className={styles.heading}>Blog</div>
          </div>
        </div>
        <div className={styles.blog_section}>
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-7">
                <div className="row">
                  <div className="col-lg-12 col-md-12 mb-0">
                    <div className={styles.blog_main}>
                      <div className={styles.blog_main_image_d}>
                        <figure className="mb-0">
                          <Image
                            src={blogState.detail.data.image}
                            alt={blogState.detail.data.title}
                            className="img-fluid"
                            layout="fill"
                            priority
                          />
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex  icon-color">
                  <div className="d-flex align-items-center me-2">
                    <p className="mt-1 mb-0">
                      <i className="bi bi-calendar-check"></i>{" "}
                      {blogState.detail.data.date}
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <p className="mt-1 mb-0">
                      | <i className="bi bi-person ms-2"></i>{" "}
                      {blogState.detail.data.user}
                    </p>
                  </div>
                </div>
                <h1 className={styles.blog_heading}>
                  {blogState.detail.data.title}
                </h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: blogState.detail.data.content,
                  }}
                ></div>
                <div className={styles.blog_new_d}>
                  <div className="d-flex justify-content-between mt-2 mb-5 border-top border-bottom">
                    <div className="d-flex align-items-center me-2">
                      <h6 className="mt-0 mb-0">Share</h6>
                    </div>
                    <div className="d-flex justify-content-end align-items-center me-2">
                      {windowAvailable && (
                        <div className={styles.social_links}>
                          <a
                            className="twitter"
                            target="_blank"
                            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                              location.href
                            )}&text=${blogState.detail.data.title}`}
                            rel="noreferrer"
                          >
                            <i className="bi bi-twitter"></i>
                          </a>
                          <a
                            className="facebook"
                            target="_blank"
                            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                              location.href
                            )}&t=${blogState.detail.data.title}`}
                            rel="noreferrer"
                          >
                            <i className="bi bi-facebook"></i>
                          </a>

                          <a
                            className="linkedin"
                            target="_blank"
                            href={`https://wa.me/?text=${encodeURIComponent(
                              location.href
                            )}`}
                            rel="noreferrer"
                          >
                            <i className="bi bi-whatsapp"></i>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="py-4 d-none">
                  <div className="col-md-12 col-lg-12 m-auto">
                    <div className="bg-white rounded-3 shadow-sm p-4">
                      <h4 className="mb-4">7 Comments</h4>

                      <div className="py-3">
                        <div className="d-flex comment">
                          <figure className={styles.rounded_circle}>
                            <Image src={features2} alt="" />
                          </figure>
                          <div className="flex-grow-1 ms-3">
                            <div className="mb-1">
                              <a href="#" className="fw-bold link-dark me-1">
                                Studio KonKon
                              </a>{" "}
                              <span className="text-muted text-nowrap">
                                2 days ago
                              </span>
                            </div>
                            {/* <div className="mb-2">
                              Lorem ipsum dolor sit amet, ut qui commodo
                              sensibus, id utinam inermis constituto vim. In nam
                              dolorum interesset, per fierent ponderum ea. Eos
                              aperiri feugiat democritum ne.
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <div className="form-floating mb-3">
                              <textarea
                                className="form-control w-100 min-h-100"
                                placeholder="Leave a comment here"
                                id="my-comment"
                              ></textarea>
                              <label htmlFor="my-comment">
                                Leave a comment here
                              </label>
                            </div>
                            <div className="hstack justify-content-end gap-2">
                              <button
                                role="button"
                                aria-label="cancel"
                                className="btn btn-sm btn-link cancel link-secondary text-uppercase"
                              >
                                cancel
                              </button>
                              <button
                                role="button"
                                aria-label="comment"
                                className="btn comment-btn btn-primary text-uppercase"
                              >
                                comment
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-5">
                <div className={styles.blog_sidebar}>
                  <h2>About us</h2>

                  <div className={styles.logo_blog}>
                    <Image
                      className="img-fluid"
                      src={require("@/assets/images/logo-blog.jpg")}
                      alt="alt"
                    />
                  </div>
                  <p className="text-center">{blogState.detail.about}</p>
                  <div className={styles.social_links1}>
                    <a href="#" className="twitter">
                      <i className="bx bxl-twitter"></i>
                    </a>
                    <a href="#" className="facebook">
                      <i className="bx bxl-facebook"></i>
                    </a>
                    <a href="#" className="google-plus">
                      <i className="bx bxl-youtube"></i>
                    </a>
                    <a href="#" className="instagram">
                      <i className="bx bxl-instagram"></i>
                    </a>

                    <a href="#" className="linkedin">
                      <i className="bx bxl-whatsapp"></i>
                    </a>
                  </div>
                </div>

                <div className={styles.category}>
                  <h3>Categories</h3>

                  <ul>
                    <li>
                      <Link href="/blog">View All</Link>
                    </li>
                    {blogState.detail.categories.map((category: any) => (
                      <li key={category.name}>
                        <Link href={`/blog/category/${category.slug}`}>
                          <a>
                            {category.name} ({category.post_count})
                          </a>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className={styles.recent_post}>
                  <h4>Recent Blogs</h4>
                  {blogState.detail.recent_posts.map((post: any) => (
                    <Link href={`/blog/${post.slug}`} key={post.slug} passHref>
                      <div className="row g-0 pointer">
                        <div className="col-lg-4 col-md-6">
                          <Image
                            className="img-fluid"
                            src={post.image}
                            alt="Post image"
                            width={110}
                            height={50}
                          />
                        </div>
                        <div className="col-lg-8 col-md-6">
                          <div className={styles.h4}>
                            {post.title.substring(0, 55)}...
                          </div>
                          <p>{post.date}</p>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

Blog.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ params, resolvedUrl }) => {
      if (!params?.slug) {
        return { notFound: true };
      }
      store.dispatch(setPath(undefined));
      const slug =
        typeof params.slug === "string" ? params.slug : params.slug?.[0];
      const canonicalUrl = getBlogCanonicalUrl(slug);
      if (canonicalUrl) {
        store.dispatch(setCanonical(canonicalUrl));
      } else {
        store.dispatch(setCanonical(undefined));
      }
      const { payload: blog } = await store.dispatch(
        fetchBlogBySlug(params.slug as string)
      );
      if (!blog) {
        return { notFound: true };
      }
      store.dispatch(setTitle(blog.data.title));
      store.dispatch(
        setMeta({
          title: blog.data.meta_title,
          description: blog.data.meta_description,
          keywords: blog.data.meta_keywords,
        })
      );
      store.dispatch(
        setMetaModifiedTime(
          moment(blog.data.date).format("YYYY-MM-DDTHH:mm:ssZ")
        )
      );
      store.dispatch(
        setOg({
          type: "website",
          url: `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
          title: blog.data.meta_title,
          description: blog.data.meta_description,
          image: blog.data.image,
        })
      );
      if (blog.data.title) store.dispatch(setIgnoreCommonTitle(true));
      try {
        const existingSchemas = [
          JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
            },
            headline: blog.data.meta_title,
            description: blog.data.meta_description,
            image: blog.data.image,
            author: {
              "@type": "Organization",
              name: "Senco Gold & Diamonds",
              url: "https://sencogoldanddiamonds.com",
            },
            publisher: {
              "@type": "Organization",
              name: "Senco Gold & Diamonds",
              logo: {
                "@type": "ImageObject",
                url: "https://sencogoldanddiamonds.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo-new.ebd8fa98.png&w=640&q=75",
              },
            },
            datePublished: blog.data.date,
            dateModified: blog.data.date,
          }),
        ];

        const metaTitle = blog.data.meta_title || blog.data.title || "";
        const metaDescription = blog.data.meta_description || "";
        const h1Text = blog.data.title || "";

        const speakableSchemaObj = {
          "@context": "https://schema.org",
          "@type": "SpeakableSpecification",
          "cssSelector": [
            `"metaTitle": "${metaTitle}"`,
            `"metaDescription": "${metaDescription}"`,
            `"H1": "${h1Text}"`,
          ],
        };

        const speakableSchemaStr = JSON.stringify(speakableSchemaObj);
        store.dispatch(setSchemas([...existingSchemas, speakableSchemaStr]));
      } catch (error) {}

      return {
        props: {},
      };
    }
);

export default Blog;
